<template lang="pug">
  .quotes
    h1 {{ msg }} You're viewing some cool affirmation quotes
    a(href='#/home') Back home

    p(v-if='!isLoading' v-for='quote in quotes') {{ quote.quote }}
</template>

<script>

import resource from '../api/resource.js';

export default {
  name: 'About',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: true,
      quotes: 'test'
    };
  },
  created() {
    const params = {
      queryParams: {
        version: 10,
        locale: 'en'
      }
    };
    this.isLoading = false;
    resource.get('affirm/3/quotes', params)
      .then((results) => {
        this.quotes = results.items.en;
        this.isLoading = false;
      })
      .catch((err) => {
        console.log(err);
        this.isLoading = false;
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Quotes.vue